export default{
    "support.admin.title"                  : "Registrars and Administrators",
    "support.admin.text"                   : "You must be connected to the HCR 3.0 to have access to our support resources. If you don't have an issue connecting to the HCR, please contact your regional Superuser or contact our Help Desk at {email} ",
    "support.participant.title"            : "Participants (Parents)",
    "support.participant.text.1"           : "We invite you to read the following tutorials:",
    "support.participant.text.2"           : "For more information and support, please contact your local hockey organization.",
    "support.participant.button.play"      : "Register to play",
    "support.participant.button.clinic"    : "Register for clinic",
    "support.participant.button.myAccount" : "My Account",
}